export default "__VITE_ASSET__toLgYPhe__"